import { useEffect, useState } from "react";
import { api } from "@/lib/api";

let _cache = null;
let _promise = null;

function load() {
  if (_cache) return Promise.resolve(_cache);
  if (!_promise) {
    _promise = api.get("/pages/public")
      .then((r) => { _cache = r.data || []; return _cache; })
      .catch(() => { _cache = []; return _cache; });
  }
  return _promise;
}

export function refreshPublicPages() {
  _cache = null;
  _promise = null;
  if (typeof window !== "undefined") window.dispatchEvent(new Event("ns:pages-updated"));
}

export function usePublicPages() {
  const [pages, setPages] = useState(_cache || []);
  useEffect(() => {
    let alive = true;
    load().then((d) => { if (alive) setPages(d); });
    const onUpd = () => { load().then((d) => { if (alive) setPages(d); }); };
    window.addEventListener("ns:pages-updated", onUpd);
    return () => { alive = false; window.removeEventListener("ns:pages-updated", onUpd); };
  }, []);
  return pages;
}
